import { createStyles } from '@mantine/core';

export default createStyles((theme) => ({
  decadeLevelGroup: {
    display: 'flex',
    gap: theme.spacing.md,
  },
}));
